window.fixProductImage = function (imgEl) {
  const productHandle = imgEl.dataset.productImage;
  if (!productHandle) return;
  fetch(`https://${window.Shopify.shop}/api/2025-10/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': window.theme.storefrontAPIToken
    },
    body: `query {
        product(handle: "${productHandle}") {
          images(first: 1) {
            nodes {
              url(transform: { maxWidth: 640 })
            }
          }
        }
      }`
  }).then(res => res.json()).then(data => {
    if (data && data.data && data.data.product && data.data.product.images && data.data.product.images.nodes && data.data.product.images.nodes[0] && data.data.product.images.nodes[0].url) {
      imgEl.src = data.data.product.images.nodes[0].url;
    } else {
      imgEl.style.opacity = 0;
    }
  });
}

function formatPriceWithSup(price) {
  const formatted = slate.Currency.formatMoney(price, window.theme.moneyFormat).replace(/<\/?[^>]+(>|$)/g, "");
  const symbol = window.theme.currentCurrencySymbol;
  if (formatted.includes(symbol)) {
    return formatted.replace(symbol, `<em class="currency-symbol">${symbol}</em>`);
  }
  return `<em class="currency-symbol">${symbol}</em>${slate.Currency.removeCurrencySymbol(formatted)}`;
}

function productPriceHtml(product) {
  const currentVariant = product.variants && product.variants.length > 0 ? (product.variants.find(v => v.available) || product.variants[0]) : {};
  const productPrice = currentVariant.price || product.price;
  const compareAtPrice = currentVariant.compareAtPrice || currentVariant.compareAtPrice || currentVariant.compare_at_price || currentVariant.compare_at_price || 0;

  return `<div class="product-card__price product-card--flex" data-original-price="${productPrice}">
                      <span class="product-prices ${compareAtPrice > productPrice ? 'discounted' : ''}">
                          ${compareAtPrice > productPrice ? `
                              <span class="product-price-regular">
                                ${formatPriceWithSup(compareAtPrice)}
                              </span>
                              <span class="sale-price-text-color product-price-discounted" data-product-price>
                                ${formatPriceWithSup(productPrice)}
                              </span>
                          ` : `
                              <span class="product-price-regular" data-product-price>
                                ${formatPriceWithSup(productPrice)}
                              </span>
                          `}
                      </span>
                      <span class="product-price-varies">
                          ${product.price_varies ? (window.theme.strings.fromPrice || 'From') : ''}
                      </span>
                       ${(compareAtPrice && compareAtPrice > productPrice) ? `<span class="product-per-off${window.theme.showPerOffMobile !== false ? ' show-per-off-mobile' : ''}${window.theme.showPerOffDesktop !== false ? ' show-per-off-desktop' : ''}">(-${100 - Math.round((productPrice / compareAtPrice) * 100)}%)</span>` : ''}
                    </div>`
}

function predictiveSearchPriceHtml(product) {
  const currentVariant = product.variants && product.variants.length > 0 ? (product.variants.find(v => v.available) || product.variants[0]) : {};
  const productPrice = currentVariant.price || product.price;
  const compareAtPrice = currentVariant.compare_at_price || product.compare_at_price || 0;

  return `<span class="product-prices ${compareAtPrice > productPrice ? 'discounted' : ''}">
          ${(compareAtPrice && compareAtPrice > productPrice) ?
      `<span class="product-price-regular">${formatPriceWithSup(compareAtPrice)}</span>
              <span class="sale-price-text-color product-price-discounted">${formatPriceWithSup(productPrice)}</span>` :
      `<span class="product-price-regular">${formatPriceWithSup(productPrice)}</span>`
    }
          </span>
          ${(compareAtPrice && compareAtPrice > productPrice) ? `<span class="product-per-off${window.theme.showPerOffMobile !== false ? ' show-per-off-mobile' : ''}${window.theme.showPerOffDesktop !== false ? ' show-per-off-desktop' : ''}">(-${100 - Math.round((productPrice / compareAtPrice) * 100)}%)</span>` : ''}`;
}

function promoCardPriceHtml(product) {
  const currentVariant = product.variants && product.variants.length > 0 ? (product.variants.find(v => v.available) || product.variants[0]) : {};
  const productPrice = currentVariant.price || product.price;
  return `<div class="price">${formatPriceWithSup(productPrice)}</div>`
}

window.updateProductData = function (productData) {
  productData.forEach((product) => {
    //console.log('updateProductData', product)
    const currentVariant = product.variants && product.variants.length > 0 ? (product.variants.find(v => v.available) || product.variants[0]) : {};
    const sku = currentVariant.sku || product.sku || false
    //console.log('sku', sku)
    const productCards = document.querySelectorAll('[data-component="ProductCard"][data-sku="' + sku + '"]');

    if (productCards.length) {
      //console.log('productCards', productCards)
      productCards.forEach((productCard) => {
        const productPrice = productCard.querySelector('.product-card__price')
        //console.log('productPrice', productPrice)
        if (productPrice) productPrice.outerHTML = productPriceHtml(product);
      })
    }
    const productSearchCards = document.querySelectorAll('predictive-search-results [data-sku="' + sku + '"]')
    if (productSearchCards.length) {
      //console.log('productSearchCards', productSearchCards)
      productSearchCards.forEach((productCard) => {
        const productPrice = productCard.querySelector('.product-card__price')
        if (productPrice) productPrice.innerHTML = predictiveSearchPriceHtml(product);
      })
    }

    const productPromoCards = document.querySelectorAll('.promotion[data-sku="' + sku + '"]')
    if (productPromoCards.length) {
      //console.log('productPromoCards', productPromoCards)
      productPromoCards.forEach((productCard) => {
        const productPrice = productCard.querySelector('.price')
        if (productPrice) productPrice.innerHTML = promoCardPriceHtml(product);
      })
    }
  })
}
window.getProductPrices = function (variantIds) {
  variantIds = variantIds.map((variantId) => {
    return typeof (variantId) === "string" ? variantId.replace('gid://shopify/ProductVariant/') : variantId
  })
  let allProducts = getAllProducts()
  let missingProducts = []
  if (allProducts.length) {
    const productData = []
    variantIds.forEach((variantId) => {
      const product = allProducts.find((prod) => { return prod.variants.some((variant) => { return variant.id == variantId || variant.id == "gid://shopify/ProductVariant/" + variantId }) })
      if (product) {
        productData.push({
          handle: product.handle,
          id: product.id,
          sku: product.sku,
          variants: product.variants.map((variant) => {
            return {
              id: variant.id,
              price: variant.price * 100,
              compareAtPrice: variant.compareAtPrice ? variant.compareAtPrice * 100 : 0,
              available: variant.available
            }
          })
        })
      } else {
        missingProducts.push(variantId)
      }
    })
    window.updateProductData(productData)
  } else {
    missingProducts = variantIds
  }
  if (missingProducts.length) {
    fetch(`https://${window.Shopify.shop}/api/2025-10/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': window.theme.storefrontAPIToken
      },
      body: `
            query getProducts @inContext(country: ${Shopify.country}) {
              ${variantIds
          .map(id => {
            if (!id) return '';
            return `p_${id}: node(id: "gid://shopify/ProductVariant/${id}") {
                  id
                  ... on ProductVariant {
                    id
                    product {
                      id
                      variants(first: 250) {
                        edges {
                          node {
                            id
                            sku
                            title
                            availableForSale
                            price {
                              amount
                            }
                            compareAtPrice {
                              amount
                            }
                          }
                        }
                      }
                    }
                  }
                }`;
          })
          .join('\n')}

            }
          `
    }).then((res) => { return res.json() }).then((json) => {
      console.log('GOT PRODUCT PRICES FROM VARIANT IDS')
      const productData = []
      Object.keys(json.data).forEach(key => {
        const product = json.data[key]?.product;
        if (product) {
          productData.push({
            id: product.id.split('/').pop(),
            variants: product.variants.edges.map(variant => ({
              id: variant.node.id.split('/').pop(),
              available: variant.node.availableForSale,
              sku: variant.node.sku,
              price: variant.node.price ? variant.node.price.amount * 100 : null,
              compareAtPrice: variant.node.compareAtPrice ? variant.node.compareAtPrice.amount * 100 : null
            })) || []
          });
        }
      });
      window.updateProductData(productData)
    })
  }
}
window.renderProductCard = function (product, settings = {}) {
  const {
    modifiers = '',
    heading = 'h4',
    type = null,
    viaFeature = null,
    gridSizing = 'medium-down--one-half medium-up--one-quarter',
  } = settings;

  // --- Helpers ---
  const escape = (str) => {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  const getSizedImageUrl = (src, size) => {
    if (!src) return '';
    // naive Shopify image size replacement
    if (typeof src === 'string') {
      return src.replace(/(\.[^.]*)$/, `_${size}$1`);
    }
    return src;
  }

  // --- Product Data Preparation ---
  const currentVariant = product.variants && product.variants.length > 0 ? (product.variants.find(v => v.available) || product.variants[0]) : {};
  // Attempt to find first available if preferred, but existing logic often defaults to first.

  const productPrice = product.price; // Assuming cents
  const compareAtPrice = product.compare_at_price || 0;
  const isAvailable = product.available === undefined ? (currentVariant.available) : product.available; // Fallback
  // Note: 'product.available' exists in some JSON representations, otherwise check variants.

  const tags = product.tags || [];

  // --- Badges Logic ---
  let badgeStyles = '';
  let badge = '';
  let fomoBadgeStyle = '';

  // 1. Collection Metafield Badges (Window.theme.collectionMetaobjects)
  let hasCollectionMetaBadge = false;
  let collectionMetaBadgeText = '';
  let collectionMetaBadgeColor = '';
  let collectionMetaBadgeBackgroundColor = '';
  let displayBottom = false;

  // Quickview Two Badge support
  let quickviewBadgeCounter = 0;
  let quickviewBadgeHtml = '';

  const collectionMetaobjects = window.theme.collectionMetaobjects || [];

  if (product.collections) {
    // Second loop: Main badge rendering logic (Matching logic in component-product-card.liquid)
    for (const meta of collectionMetaobjects) {
      if (meta.collections && meta.collections.length > 0) {
        const matchFound = meta.collections.some(c => product.collections.some(pc => String(pc.handle) === String(c.handle)));
        if (matchFound) {
          hasCollectionMetaBadge = true;
          collectionMetaBadgeText = meta.badge_text;
          collectionMetaBadgeColor = meta.badge_text_color;
          collectionMetaBadgeBackgroundColor = meta.badge_background_color;

          if (meta.display_below_product_image) {
            displayBottom = meta.display_below_product_image;
          }

          badge = meta.badge_text;
          badgeStyles = `background-color: ${meta.badge_background_color}; color: ${meta.badge_text_color};`;
          if (meta.badge_border_color) {
            badgeStyles += ` border-color:${meta.badge_border_color};`;
          }
          if (meta.opacity) {
            badgeStyles += ` opacity:${meta.opacity};`;
          }
          if (meta.fomo_style == true) {
            fomoBadgeStyle = 'fomo-badge';
          } else if (meta.default_style == true) {
            fomoBadgeStyle = 'default-badge';
          }
          break; // Stop after first match for main product card badge
        }
      }
    }
  }

  // 2. Tag Badges (badge:TEXT:BG:COLOR or 'New')
  // We strictly use normal string matches for badge assignment to be fully compatible with component-product-card.liquid
  if (!badge) {
    for (const tag of tags) {
      if (tag.includes('badge:')) {
        const parts = tag.split(':');
        badge = parts[1];
        badgeStyles = '';
        if (parts[2]) {
          badgeStyles += `background-color: ${parts[2]};`;
        }
        if (parts[3]) {
          badgeStyles += ` color: ${parts[3]};`;
        }
        if (badge.toLowerCase() === 'new') break;
      }
    }
  }

  // 3. Offer Logic
  let offer = '';
  let offerProperty = '';
  /*
  for (const tag of tags) {
    if (tag.includes('offer:')) {
      offer = tag.split(':')[1];
      break;
    }
  }
  */
  if (offer) {
    const offerArray = offer.split('-');
    if (offerArray.length > 1) {
      offerProperty = `${offerArray[0]}-${offerArray[offerArray.length - 1]}`;
    }
  }

  // --- Classes ---
  let classes = 'product-card product-card--quick';
  if (modifiers) {
    modifiers.split(' ').forEach(mod => classes += ` product-card--${mod}`);
  }

  // --- Data Attributes ---
  let dataAttrs = `class="${classes}"`;
  if (offerProperty) dataAttrs += ` data-offer="${offerProperty}"`;
  dataAttrs += ` data-component="ProductCard"`;
  dataAttrs += ` data-product-title="${escape(product.title)}"`;
  if (currentVariant.sku) dataAttrs += ` data-sku="${currentVariant.sku}"`;
  dataAttrs += ` data-value="${productPrice / 100}"`;
  dataAttrs += ` data-product-vendor="${escape(product.vendor)}"`;
  dataAttrs += ` data-product-type="${escape(product.type)}"`;
  if (type) dataAttrs += ` data-type="${type}"`;

  // --- Image URL Logic ---
  let productUrl = product.url;
  if (viaFeature && type) {
    const sep = productUrl.includes('?') ? '&' : '?';
    productUrl += `${sep}via-feature=${viaFeature}&feature-type=${type}`;
  }

  const featuredImage = product.featured_image || (product.images ? product.images[0] : '');
  const secondaryImage = (product.images && product.images[1]);

  // --- In Store Check ---
  const isOnlyInStore = tags.some(tag => typeof tag === 'string' && tag.trim().toLowerCase() === 'in-store');


  // --- PROMO CALLOUT Logic ---
  let promoHtml = '';

  let promo_callouts = window.theme.promo_callout_metaobject
  let promo_status = false;
  let promo_text = "";
  let promo_style = "";
  let promo_link = "";

  const matchedCurrentCollection = promo_callouts.find(c => String(c.handle || c.collection_url?.split('/').pop()) === String(window.theme.currentPageHandle));
  if (matchedCurrentCollection) {
    promo_text = matchedCurrentCollection.promo_text;
    promo_style = matchedCurrentCollection.text_colour;
    promo_link = `/collections/${window.theme.currentPageHandle}`;
    promo_status = true;
  } else {
    if (promo_callouts && product.collections) {
      for (const promo of promo_callouts) {
        // Check if matching collection
        const promoHandle = promo.handle || promo.collection_url?.split('/').pop();
        const matchedCollection = product.collections.find(c => {
          const cHandle = typeof c === 'object' && c !== null ? c.handle : c;
          const cId = typeof c === 'object' && c !== null ? c.id : null;
          return (cId && String(cId) === String(promo.id)) || (cHandle && String(cHandle) === String(promoHandle));
        });
        if (matchedCollection) {
          promo_text = promo.promo_text;
          promo_style = promo.text_colour;
          promo_link = `/collections/${matchedCollection.handle || promoHandle}`;
          promo_status = true;

          break;
        }
      }
    }
  }

  // --- MULTIBUY Logic ---
  const multibuy_offer_discounts = window.theme.multibuy_offer_discounts || [];
  for (let i = 0; i < multibuy_offer_discounts.length; i++) {
    const discount_type = multibuy_offer_discounts[i].discount_type;
    const discount_key = multibuy_offer_discounts[i].discount_key;
    const collection_handle = multibuy_offer_discounts[i].collectionHandle || '';
    
    if (!discount_key) continue;

    if (discount_type === "collection" && product.collections && collection_handle) {
      const matchedCollection = product.collections.find(c => {
        const cHandle = typeof c === 'object' && c !== null ? c.handle : c;
        return String(cHandle) === String(collection_handle);
      });
      if (matchedCollection) {
        promo_text = (multibuy_offer_discounts[i].description || multibuy_offer_discounts[i].title || "");
        promo_link = multibuy_offer_discounts[i].collectionUrl || `/collections/${collection_handle}`;
        promo_style = multibuy_offer_discounts[i].color || "";
        promo_status = true;
        break;
      }
    } else if (discount_type === "tag" && product.tags && product.tags.includes(discount_key)) {
      promo_text = (multibuy_offer_discounts[i].description || multibuy_offer_discounts[i].title || "");
      promo_link = `/collections/all/tagged/${discount_key}`;
      promo_style = multibuy_offer_discounts[i].color || "";
      promo_status = true;
      break;
    }
  }

  if (promo_status) {
    promoHtml = `
            <a href="${promo_link}"${promo_style ? ` style="color:${promo_style}"` : ''} class="promo_callout" data-text="${promo_text.replace(/\"|\'/g, '').replace(/\s/g, '')}" data-currency="${window.theme.currentCurrency}">
                <svg class="plp-promo-img" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M3.65389 9.52002L2.72989 6.95802C2.61322 7.00469 2.30709 7.10922 1.73589 7.32202C1.0079 7.61602 1.03359 8.13402 1.06389 8.28802C1.1059 8.66602 1.4979 9.59059 1.67989 9.75802C1.92337 9.98202 2.45922 9.94002 2.67389 9.87002L3.65389 9.52002Z" fill="currentColor"/>
                  <path d="M4.0879 9.35202L3.1639 6.79002C4.4855 6.29722 5.92657 4.87669 6.4819 4.22802C6.94857 5.52535 7.9631 8.33282 8.2879 9.18402C6.5855 8.87042 4.77857 9.16535 4.0879 9.35202Z" fill="currentColor"/>
                  <path d="M4.3679 9.73002L3.0799 10.192C3.4719 10.57 4.3063 11.3792 4.5079 11.592C4.7179 11.858 4.9979 11.886 5.1799 11.774C5.3927 11.6172 5.34324 11.3634 5.2919 11.256L4.3679 9.73002Z" fill="currentColor"/>
                  <path d="M7.0839 3.24802C6.7591 3.36002 6.7619 3.68669 6.8039 3.83602C7.42924 5.54869 8.7023 9.04122 8.7919 9.31002C8.8899 9.52002 9.1979 9.63202 9.4079 9.53402C9.6543 9.42202 9.6879 9.15135 9.6739 9.03002C9.06724 7.36869 7.8147 3.93962 7.6579 3.51402C7.5739 3.30402 7.3219 3.16402 7.0839 3.24802Z" fill="currentColor"/>
                  <path d="M11.0422 2.24694C11.1472 2.02294 11.0492 1.74994 10.8322 1.64494C10.6152 1.53994 10.3352 1.64494 10.2302 1.86194L9.64217 3.09394C9.53717 3.31794 9.63517 3.58394 9.85217 3.69594C10.0692 3.80794 10.3492 3.70994 10.4542 3.48594L11.0422 2.25394V2.24694Z" fill="currentColor"/>
                  <path d="M11.4761 4.613C11.2451 4.697 11.1261 4.95599 11.2031 5.18699C11.2801 5.41799 11.5461 5.544 11.7771 5.46L13.0441 5.005C13.2751 4.928 13.4011 4.66199 13.3171 4.43099C13.2331 4.20699 12.9741 4.08099 12.7431 4.15799L11.4691 4.60599L11.4761 4.613Z" fill="currentColor"/>
                  <path d="M12.5401 8.38602C12.7641 8.49102 13.0371 8.39302 13.1421 8.17602C13.2471 7.95902 13.1421 7.67902 12.9251 7.57402L11.6931 6.98602C11.4691 6.88102 11.1961 6.97202 11.0911 7.19602C10.9861 7.42002 11.0841 7.69302 11.3011 7.79802L12.5331 8.38602H12.5401Z" fill="currentColor"/>
                </svg>
                <svg class="quickview-promo-img" style="display:none;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M0.912008 10.752C1.28001 11.776 2.00801 12.2 3.00001 11.984L4.68001 13.696C5.11201 14.136 5.53601 14.272 6.03201 14.096C6.67201 13.864 6.96801 13.232 6.56801 12.552L5.73601 11.152C6.97601 10.952 8.30401 10.952 9.60801 11.176C9.92001 11.568 10.416 11.704 10.944 11.52C11.608 11.28 11.896 10.648 11.656 9.98397L9.40001 3.79197C9.16001 3.12797 8.52801 2.83197 7.86401 3.07197C7.32801 3.26397 7.03201 3.71997 7.06401 4.23197C6.07201 5.43997 4.63201 6.52797 3.38401 7.13597L1.88801 7.67997C0.688008 8.11197 0.272008 8.97597 0.688008 10.136L0.912008 10.744V10.752ZM10.176 10.528L7.92001 4.33597C7.84801 4.12797 7.93601 3.93597 8.14401 3.86397C8.35201 3.79197 8.54401 3.87997 8.61601 4.08797L10.872 10.28C10.944 10.488 10.856 10.68 10.656 10.752C10.456 10.824 10.256 10.736 10.184 10.528H10.176ZM4.76001 10.52L3.79201 7.85597C5.16801 7.15997 6.38401 6.25597 7.33601 5.14397L9.21601 10.32C7.74401 10.072 6.24801 10.168 4.75201 10.52H4.76001ZM3.12801 11.088C2.36801 11.368 1.96001 11.192 1.69601 10.472L1.47201 9.86397C1.20801 9.14397 1.40801 8.75197 2.17601 8.47197L3.02401 8.16797L3.97601 10.792L3.12801 11.096V11.088ZM5.33601 13.216L3.82401 11.72L4.88801 11.336C4.88801 11.336 4.92001 11.336 4.93601 11.32L5.89601 12.912C6.02401 13.112 5.94401 13.296 5.76001 13.368C5.59201 13.424 5.48801 13.368 5.33601 13.216Z" fill="currentColor"/>
                    <path d="M12.832 2.56805C12.952 2.31205 12.84 2.00005 12.592 1.88005C12.344 1.76005 12.024 1.88005 11.904 2.12805L11.232 3.53605C11.112 3.79205 11.224 4.09605 11.472 4.22405C11.72 4.35205 12.04 4.24005 12.16 3.98405L12.832 2.57605V2.56805Z" fill="currentColor"/>
                    <path d="M13.328 5.27199C13.064 5.36799 12.928 5.66399 13.016 5.92799C13.104 6.19199 13.408 6.33599 13.672 6.23999L15.12 5.71999C15.384 5.63199 15.528 5.32799 15.432 5.06399C15.336 4.80799 15.04 4.66399 14.776 4.75199L13.32 5.26399L13.328 5.27199Z" fill="currentColor"/>
                    <path d="M14.544 9.58402C14.8 9.70402 15.112 9.59202 15.232 9.34402C15.352 9.09602 15.232 8.77602 14.984 8.65602L13.576 7.98402C13.32 7.86402 13.008 7.96802 12.888 8.22402C12.768 8.48002 12.88 8.79202 13.128 8.91202L14.536 9.58402H14.544Z" fill="currentColor"/>
                </svg>
                <span>${theme.CurrencySwitcher.getCurrencyHTML(promo_text, false, true)}</span>
            </a>
            `;
  }


  // --- HTML Build ---
  let html = `<div class="html2 product-card-wrapper quickview-open ${gridSizing}">
  <a href="${productUrl}" title="${escape(product.title)}" class="collection__product-link">
  <div ${dataAttrs}>`;

  // 1. Image Section
  if (featuredImage) {
    const aspectRatioClass = ''; // Logic omitted for brevity, usually check height/width
    html += `<div class="product-card__image ${aspectRatioClass}">
                 <div class="product-card__image--wrapper">`;

    if (product.images && product.images.length > 1) {
      if( window.innerWidth >= theme.settings.grid_medium ) {
        // Desktop: render primary and secondary images with hover swap
        html += `<div data-image-slider>
                      <span class="primary-image">
                          <div class="product-card__image--cover"></div>
                          ${`<img src="${getSizedImageUrl(featuredImage, '640x')}" class="product-card__img" alt="${escape(product.title)}" />`}
                      </span>
                      <span class="secondary-image">
                          <div class="product-card__image--cover"></div>
                          ${`<img src="${getSizedImageUrl(secondaryImage, '640x')}" class="product-card__img" alt="${escape(product.title)}" />`}
                      </span>
                    </div>`;
      } else {
        // Mobile: render all images in a slider
        let slider_html = '';
        product.images.forEach(function(image){
          slider_html = `${slider_html}
            <div class="product-card-image swiper-slide"> 
              <div class="product-card__image--cover"></div>
              ${`<img src="${getSizedImageUrl(image, '640x')}" class="product-card__img" alt="${escape(product.title)}" />`}
            </div>
            `
        })
        html +=`<product-card-slider class="image_slider" data-image-slider>
                <div class="swiper">
                  <div class="swiper-wrapper">
                    ${slider_html}
                  </div>
                  <div class="swiper-pagination"></div>
                </div>
              </<product-card-slider>
            `
      }
    } else {
      html += `<img src="${getSizedImageUrl(featuredImage, '640x')}" class="product-card__img" data-product-handle="${escape(product.handle)}" onerror="window.fixProductImage(this)" alt="${escape(product.title)}" />`;
    }
    html += `</div>`

    html += `<div class="product-card__actions ${isOnlyInStore ? 'hide' : ''}">`

    //html += `<product-quick-view class="quickview" data-product-handle="${product.handle}">
    //             <button class="open-quickview" data-product="${product.handle}">
    //                 <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                     <rect x="0.25" y="0.251465" width="31.5" height="31.4986" rx="15.7493" fill="white" fill-opacity="0.5"/>
    //                     <rect x="0.25" y="0.251465" width="31.5" height="31.4986" rx="15.7493" stroke="#333333" stroke-width="0.5"/>
    //                     <path fill-rule="evenodd" clip-rule="evenodd" d="M21.8307 13.3455C22.8662 14.4253 23.5724 15.6147 23.9331 16.4919C24.0223 16.7091 24.0223 16.9505 23.9331 17.1677C23.5277 18.1491 22.6521 19.5569 21.355 20.7797C20.0497 21.9864 18.2498 23.0001 16.0041 23.0001C13.7583 23.0001 11.9584 21.9864 10.6532 20.7797C9.34786 19.565 8.48036 18.1491 8.06689 17.1677C7.9777 16.9505 7.9777 16.7091 8.06689 16.4919C8.42022 15.6326 9.11103 14.4795 10.114 13.4143L9.34759 12.7784C9.10163 12.5743 9.06746 12.2107 9.27125 11.9663C9.47504 11.722 9.83963 11.6893 10.0856 11.8934L10.9534 12.6134C11.4637 12.1792 12.0411 11.7798 12.6834 11.4568L12.0808 10.4252C11.9199 10.1499 12.0128 9.79624 12.2881 9.63539C12.5635 9.47454 12.9171 9.56737 13.078 9.84273L13.7615 11.013C14.2023 10.8702 14.6675 10.7654 15.1565 10.7085L15.1565 9.57889C15.1565 9.25999 15.415 9.00146 15.7339 9.00146C16.0528 9.00146 16.3113 9.25999 16.3113 9.57889V10.6659C16.7738 10.6851 17.2166 10.7473 17.6393 10.8448L18.2168 9.84513C18.3763 9.569 18.7295 9.47447 19.0056 9.634C19.2818 9.79352 19.3763 10.1467 19.2168 10.4228L18.7662 11.2028C19.604 11.5444 20.3442 12.0203 20.9821 12.5523L21.7762 11.8934C22.0222 11.6893 22.3868 11.722 22.5906 11.9664C22.7944 12.2108 22.7602 12.5743 22.5142 12.7784L21.8307 13.3455ZM20.4469 19.8144C19.3038 20.8682 17.812 21.6807 16.0041 21.6807C14.1961 21.6807 12.7043 20.8682 11.5612 19.8144C10.491 18.8249 9.75323 17.6584 9.37218 16.8298C9.75323 15.9771 10.491 14.8347 11.5612 13.8452C12.7043 12.7914 14.1961 11.9789 16.0041 11.9789C17.812 11.9789 19.3038 12.7914 20.4469 13.8452C21.5171 14.8347 22.2306 15.9771 22.6359 16.8298C22.2306 17.6584 21.5171 18.8249 20.4469 19.8144ZM16.0035 19.4765C17.4767 19.4765 18.6709 18.2916 18.6709 16.8298C18.6709 15.3681 17.4767 14.1831 16.0035 14.1831C14.5304 14.1831 13.3362 15.3681 13.3362 16.8298C13.3362 18.2916 14.5304 19.4765 16.0035 19.4765Z" fill="#333333"/>
    //                 </svg>
    //             </button>
    //         </product-quick-view>`

    html += `     <form action="/cart/add" method="post" enctype="multipart/form-data" class="form">
                        <input type="hidden" name="quantity" value="1">
                        <select name="id" class="no-js" aria-label="${window.theme.strings.selectVariant}" data-product-select>
                            ${product.variants.map(variant => `
                                <option value="${variant.id}" 
                                    ${variant.id === currentVariant.id ? 'selected="selected"' : ''}
                                    ${!variant.available ? 'disabled="disabled"' : ''}>
                                    ${escape(variant.title)}
                                </option>
                            `).join('')}
                        </select>
                        
                        ${!product.has_only_default_variant ? `
                            <div class="product-card__variant-picker product-card__variant-picker--with-options">
                                <span class="variant-picker__message visually-hidden" tabindex="-1">${window.theme.strings.selectOption}</span>
                                <div role="list" class="product-card__variants">
                                    ${product.variants.map(variant => `
                                        <div role="listitem" class="product-card__variant-container">
                                            <button class="btn btn--text add-product-variant" data-variant-id="${variant.id}" ${!variant.available ? 'disabled' : ''}>${escape(variant.title)}</button>
                                        </div>
                                    `).join('')}
                                     <div role="listitem" class="product-card__variant-container">
                                        <button type="button" class="close-show-variants" aria-label="${window.theme.strings.closeVariants || 'Close'}">
                                            <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path id="close" d="M1.6129 0.234883C1.29972 -0.0782944 0.791957 -0.0782944 0.47878 0.234883C0.165602 0.548061 0.165602 1.05582 0.47878 1.369L5.10978 6L0.478828 10.631C0.16565 10.9441 0.16565 11.4519 0.478828 11.7651C0.792005 12.0782 1.29977 12.0782 1.61294 11.7651L6.2439 7.13412L10.8748 11.7651C11.188 12.0782 11.6958 12.0782 12.009 11.7651C12.3221 11.4519 12.3221 10.9441 12.009 10.631L7.37801 6L12.009 1.369C12.3222 1.05582 12.3222 0.548061 12.009 0.234883C11.6958 -0.0782944 11.1881 -0.0782944 10.8749 0.234883L6.2439 4.86588L1.6129 0.234883Z" fill="#999999"/>
                                            </svg>
                                        </button>
                                     </div>
                                </div>
                                <div role="list" class="product-card__mobile-variants">
                                    ${product.variants.map(variant => `
                                        <div role="listitem">
                                            <button class="product-card__variant add-product-variant" data-variant-id="${variant.id}" ${!variant.available ? 'disabled' : ''} aria-label="Select variant ${escape(variant.title)} for ${escape(product.title)}">
                                                <span class="product-card__variant-text">${escape(variant.title)}</span> 
                                                <!-- Icon Checkmark Omitted for brevity, can add if needed -->
                                            </button>
                                        </div>
                                    `).join('')}
                                </div>
                            </div>
                            
                            <button class="product__add--show-variants" type="button" aria-label="${window.theme.strings.addToCart}" ${!currentVariant.available ? 'disabled="disabled"' : ''}>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" fill="white" fill-opacity="0.5"/>
                                    <rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" stroke="#999999" stroke-width="0.5"/>
                                    <g clip-path="url(#clip0_750_7208)">
                                    <path d="M22.6755 11.5823C22.5551 11.4619 22.382 11.3866 22.2089 11.3866H19.477C19.4544 10.4911 19.0932 9.65569 18.461 9.01599C17.8288 8.37629 16.9332 8 16 8C15.0668 8 14.1938 8.36124 13.5391 9.01599C12.9069 9.64817 12.5457 10.4911 12.5231 11.3866H9.79118C9.61809 11.3866 9.45252 11.4544 9.32458 11.5823C9.19664 11.7103 9.12891 11.8758 9.12891 12.0489V23.3377C9.12891 23.5108 9.19664 23.6839 9.32458 23.8043C9.45252 23.9247 9.61056 24 9.79118 24H22.2089C22.382 24 22.5551 23.9323 22.6755 23.8043C22.7959 23.6764 22.8711 23.5108 22.8711 23.3377V12.0489C22.8711 11.8758 22.8034 11.7027 22.6755 11.5823ZM21.5541 19.2888H10.4535V12.7037H12.5231V14.2992C12.5231 14.4722 12.5908 14.6453 12.7187 14.7658C12.8467 14.8862 13.0047 14.9614 13.1854 14.9614H13.8476V12.7037H18.175V14.9614H18.8373C19.0104 14.9614 19.1835 14.8937 19.3039 14.7658C19.4243 14.6378 19.4996 14.4722 19.4996 14.2992V12.7037H21.5692V19.2888H21.5541ZM10.4535 20.6058H21.5541V22.6754H10.4535V20.6058ZM13.8401 11.3866C13.8627 10.8448 14.0885 10.3405 14.4723 9.9492C14.8787 9.5428 15.4281 9.31703 16 9.31703C16.572 9.31703 17.1214 9.5428 17.5278 9.9492C17.9116 10.333 18.1374 10.8523 18.16 11.3866H13.8401Z" fill="#333333"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_750_7208">
                                    <rect width="13.7422" height="16" fill="white" transform="translate(9.12891 8)"/>
                                    </clipPath>
                                    </defs>
                                </svg>
                            </button>
                            <button type="button" class="product__add--mobile product__add--show-variants" aria-label="${window.theme.strings.addToCart}">
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" fill="white" fill-opacity="0.5"/>
                                    <rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" stroke="#999999" stroke-width="0.5"/>
                                    <g clip-path="url(#clip0_750_7208)">
                                    <path d="M22.6755 11.5823C22.5551 11.4619 22.382 11.3866 22.2089 11.3866H19.477C19.4544 10.4911 19.0932 9.65569 18.461 9.01599C17.8288 8.37629 16.9332 8 16 8C15.0668 8 14.1938 8.36124 13.5391 9.01599C12.9069 9.64817 12.5457 10.4911 12.5231 11.3866H9.79118C9.61809 11.3866 9.45252 11.4544 9.32458 11.5823C9.19664 11.7103 9.12891 11.8758 9.12891 12.0489V23.3377C9.12891 23.5108 9.19664 23.6839 9.32458 23.8043C9.45252 23.9247 9.61056 24 9.79118 24H22.2089C22.382 24 22.5551 23.9323 22.6755 23.8043C22.7959 23.6764 22.8711 23.5108 22.8711 23.3377V12.0489C22.8711 11.8758 22.8034 11.7027 22.6755 11.5823ZM21.5541 19.2888H10.4535V12.7037H12.5231V14.2992C12.5231 14.4722 12.5908 14.6453 12.7187 14.7658C12.8467 14.8862 13.0047 14.9614 13.1854 14.9614H13.8476V12.7037H18.175V14.9614H18.8373C19.0104 14.9614 19.1835 14.8937 19.3039 14.7658C19.4243 14.6378 19.4996 14.4722 19.4996 14.2992V12.7037H21.5692V19.2888H21.5541ZM10.4535 20.6058H21.5541V22.6754H10.4535V20.6058ZM13.8401 11.3866C13.8627 10.8448 14.0885 10.3405 14.4723 9.9492C14.8787 9.5428 15.4281 9.31703 16 9.31703C16.572 9.31703 17.1214 9.5428 17.5278 9.9492C17.9116 10.333 18.1374 10.8523 18.16 11.3866H13.8401Z" fill="#333333"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_750_7208">
                                    <rect width="13.7422" height="16" fill="white" transform="translate(9.12891 8)"/>
                                    </clipPath>
                                    </defs>
                                </svg>
                            </button>
                        ` : `
                            ${!isOnlyInStore ? `
                                <button class="product__add" type="submit" name="add" data-add-to-cart aria-label="${window.theme.strings.addToCart}" ${!currentVariant.available ? 'disabled="disabled"' : ''}>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" fill="white" fill-opacity="0.5"/>
                                        <rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" stroke="#999999" stroke-width="0.5"/>
                                        <g clip-path="url(#clip0_750_7208)">
                                        <path d="M22.6755 11.5823C22.5551 11.4619 22.382 11.3866 22.2089 11.3866H19.477C19.4544 10.4911 19.0932 9.65569 18.461 9.01599C17.8288 8.37629 16.9332 8 16 8C15.0668 8 14.1938 8.36124 13.5391 9.01599C12.9069 9.64817 12.5457 10.4911 12.5231 11.3866H9.79118C9.61809 11.3866 9.45252 11.4544 9.32458 11.5823C9.19664 11.7103 9.12891 11.8758 9.12891 12.0489V23.3377C9.12891 23.5108 9.19664 23.6839 9.32458 23.8043C9.45252 23.9247 9.61056 24 9.79118 24H22.2089C22.382 24 22.5551 23.9323 22.6755 23.8043C22.7959 23.6764 22.8711 23.5108 22.8711 23.3377V12.0489C22.8711 11.8758 22.8034 11.7027 22.6755 11.5823ZM21.5541 19.2888H10.4535V12.7037H12.5231V14.2992C12.5231 14.4722 12.5908 14.6453 12.7187 14.7658C12.8467 14.8862 13.0047 14.9614 13.1854 14.9614H13.8476V12.7037H18.175V14.9614H18.8373C19.0104 14.9614 19.1835 14.8937 19.3039 14.7658C19.4243 14.6378 19.4996 14.4722 19.4996 14.2992V12.7037H21.5692V19.2888H21.5541ZM10.4535 20.6058H21.5541V22.6754H10.4535V20.6058ZM13.8401 11.3866C13.8627 10.8448 14.0885 10.3405 14.4723 9.9492C14.8787 9.5428 15.4281 9.31703 16 9.31703C16.572 9.31703 17.1214 9.5428 17.5278 9.9492C17.9116 10.333 18.1374 10.8523 18.16 11.3866H13.8401Z" fill="#333333"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_750_7208">
                                        <rect width="13.7422" height="16" fill="white" transform="translate(9.12891 8)"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </button>
                                <button class="product__add--mobile" type="submit" name="add" data-add-to-cart aria-label="${window.theme.strings.addToCart}">
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" fill="white" fill-opacity="0.5"/>
                                        <rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" stroke="#999999" stroke-width="0.5"/>
                                        <g clip-path="url(#clip0_750_7208)">
                                        <path d="M22.6755 11.5823C22.5551 11.4619 22.382 11.3866 22.2089 11.3866H19.477C19.4544 10.4911 19.0932 9.65569 18.461 9.01599C17.8288 8.37629 16.9332 8 16 8C15.0668 8 14.1938 8.36124 13.5391 9.01599C12.9069 9.64817 12.5457 10.4911 12.5231 11.3866H9.79118C9.61809 11.3866 9.45252 11.4544 9.32458 11.5823C9.19664 11.7103 9.12891 11.8758 9.12891 12.0489V23.3377C9.12891 23.5108 9.19664 23.6839 9.32458 23.8043C9.45252 23.9247 9.61056 24 9.79118 24H22.2089C22.382 24 22.5551 23.9323 22.6755 23.8043C22.7959 23.6764 22.8711 23.5108 22.8711 23.3377V12.0489C22.8711 11.8758 22.8034 11.7027 22.6755 11.5823ZM21.5541 19.2888H10.4535V12.7037H12.5231V14.2992C12.5231 14.4722 12.5908 14.6453 12.7187 14.7658C12.8467 14.8862 13.0047 14.9614 13.1854 14.9614H13.8476V12.7037H18.175V14.9614H18.8373C19.0104 14.9614 19.1835 14.8937 19.3039 14.7658C19.4243 14.6378 19.4996 14.4722 19.4996 14.2992V12.7037H21.5692V19.2888H21.5541ZM10.4535 20.6058H21.5541V22.6754H10.4535V20.6058ZM13.8401 11.3866C13.8627 10.8448 14.0885 10.3405 14.4723 9.9492C14.8787 9.5428 15.4281 9.31703 16 9.31703C16.572 9.31703 17.1214 9.5428 17.5278 9.9492C17.9116 10.333 18.1374 10.8523 18.16 11.3866H13.8401Z" fill="#333333"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_750_7208">
                                    <rect width="13.7422" height="16" fill="white" transform="translate(9.12891 8)"/>
                                    </clipPath>
                                    </defs>
                                </svg>
                            </button>
                            ` : ''}
                        `}
                    </form>
                  </div>

                 ${badge && !offerProperty ? `
                    <div class="product-card__badge ${hasCollectionMetaBadge ? 'product-card__badge--badge' : ''} ${fomoBadgeStyle}" ${badgeStyles ? `style="${badgeStyles}"` : ''}>
                        ${escape(badge)}
                    </div>
                  ` : ''}

                  ${offerProperty ? `
                    <div class="product-card__badge ${hasCollectionMetaBadge ? 'product-card__badge--badge' : ''}">
                        ${offer.split('-')[0]} for ${window.theme.currencySymbol || window.theme.currentCurrencySymbol}${offer.split('-').pop()}
                    </div>
                  ` : ''}                  
              </div>`;
  }

  // 2. Info Section
  html += `<div class="product-card__info">
              <div class="product-card__details">
                  
                  <div class="product-card__text">
                    ${promoHtml}
                     <${heading} class="product-card__title">
                         <span>${escape(product.title)}</span>
                     </${heading}>

                     ${productPriceHtml(product)}
                  </div>
              </div>
           </div>
           
           <script type="application/json" data-product-json>${JSON.stringify(product)}</script>
           

          </div>
           </a>
           </div>`; // End root

  return html;
}


if (!window.customElements.get('product-quick-view')) {
  class ProductQuickView extends HTMLElement {
    constructor() {
      super();
      this.handle = this.getAttribute('data-product-handle');
      this.button = this.querySelector('button') || this
      this.button.addEventListener('click', (e) => {
        this.openQuickView()
      });
    }

    openQuickView() {
      this.button.classList.add('btn--loading')
      fetch(`/products/${this.handle}?section_id=quickview-template`)
        .then(response => response.text())
        .then(html => {

          quickViewWrapper.innerHTML = html;
          $('.product-quickview .product__images').slick({
            accessibility: true,
            arrows: true,
            dots: false,
            infinite: false,
            lazyLoad: 'progressive',
            swipeToSlide: true,
            rows: 0,
            responsive: [
              {
                breakpoint: Number(theme.settings.grid_medium),
                settings: {
                  arrows: false,
                  dots: true,
                },
              },
            ],
          });
          quickViewWrapper.classList.add('is-active');

          const getSiblingQv = (which) => {
            const thisClosest = this.closest('.product-card-wrapper.swiper-slide')?.closest('.slick-slide') || this.closest('.product-card-wrapper')
            if (!thisClosest) return null
            return thisClosest?.[which]?.querySelector('product-quick-view') || thisClosest?.[which]?.[which]?.querySelector('product-quick-view') || thisClosest?.[which]?.[which]?.[which]?.querySelector('product-quick-view') || thisClosest?.[which]?.[which]?.[which]?.[which]?.querySelector('product-quick-view')
          }

          let prevQV = getSiblingQv('previousElementSibling')
          if (prevQV.querySelector('button')) prevQV = prevQV.querySelector('button')
          if (prevQV) {
            const prev = document.createElement('button')
            prev.classList.add('quickview-prev', 'quickview-prev-product')
            prev.innerHTML = `<svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path id="chevron-down" d="M6.611 1.4V0L0 7l6.611 7V1.4Z" fill="#333333"></path>
        </svg>`
            quickViewWrapper.querySelector('.quickview__content').appendChild(prev)
            prev.addEventListener('click', (e) => {
              prevQV.click()
            })
          }

          let nextQV = getSiblingQv('nextElementSibling')
          if (nextQV.querySelector('button')) nextQV = nextQV.querySelector('button')
          if (nextQV) {
            const next = document.createElement('button')
            next.classList.add('quickview-next', 'quickview-next-product')
            next.innerHTML = `<svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path id="chevron-down" d="M0.388914 1.4L0.388944 0L7.00006 6.99999L0.388971 14L0.388941 12.6L0.388971 7.00001L0.388914 1.4Z" fill="#333333"></path>
        </svg>`
            next.addEventListener('click', (e) => {
              nextQV.click()
            })
            quickViewWrapper.querySelector('.quickview__content').appendChild(next)
          }

          this.button.classList.remove('btn--loading')

        }).catch(error => {
          console.log('Quickview error', error)
          this.button.classList.remove('btn--loading')
        })
    }
  }
  customElements.define('product-quick-view', ProductQuickView);


  const quickViewWrapper = document.createElement('div');
  quickViewWrapper.classList.add('quickview');
  quickViewWrapper.classList.add('product-quickview');
  document.body.appendChild(quickViewWrapper);
  function closeQuickview() {
    quickViewWrapper.classList.remove('is-active');
    quickViewWrapper.innerHTML = '';
  }
  quickViewWrapper.addEventListener('click', (e) => {
    if (!e.target.closest('.quickview__content') && !e.target.classList.contains('.quickview__content')) closeQuickview();
    if (e.target.closest('.quickview__close') || e.target.classList.contains('quickview__close')) closeQuickview();
  });
}